import { useContext, useEffect, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../common/Modal'
import { NavContext } from '../../../context/global_context'
import { useParams } from 'react-router-dom'
import { postRequest } from '../../../services/base'
import MemosRow from './TracerMemosRow'
import NoRecordsFound from '../../common/NoRecordsFound'
import { MemoContext, SHOW_FETCH_MEMO_POPUP } from './context/context'
import MemoHeader from './MemoHeader'
import Button from '../../common/Button'

const TracerMemos = ({ getListData }) => {
  let { vehicle } = useParams()

  const [memos, setMemos] = useState([])
  const [atMemos, setAtMemos] = useState({})
  const [memoList, setMemoList] = useState([])
  const [totalMemos, setTotalMemos] = useState(10)
  const [crowdSource, setCrowdSource] = useState({})
  const [selectedItem, setSelectedItem] = useState({})
  const [recordType, setRecordType] = useState('new')

  const [state, dispatch] = useContext(NavContext)
  const [memoState, memoDispatch] = useContext(MemoContext)

  useEffect(() => {
    if (memoState.show_fetch_memo_popup) {
      setRecordType('new')
      importAllFromTracer()
    }
  }, [memoState.show_fetch_memo_popup])

  const importAllFromTracer = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching memos from Tracer',
        showLoader: true,
      },
      notification: {},
    })

    let formData = new FormData()
    formData.append(
      'updated_after',
      memoState.memos_date ? memoState.memos_date : ''
    )

    let res = await postRequest(
      `/api/dtc_memos/tracer_memos/${vehicle}/`,
      formData
    )
    if (res?.status) {
      if (!res.data.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res.data.data,
          },
        })
      } else {
        setCrowdSource(res.crowd_src_memo_log)
        setMemoList(res.data.data.memos)
        setMemos(
          filterMemos(res.data.data.memos, res.at_memos, res.crowd_src_memo_log)
        )
        setAtMemos(res.at_memos)
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Completed memos fetching from Tracer',
          },
        })
      }
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res.msg,
        },
      })
    }
  }

  const filterMemos = (
    tracerMemos,
    atMemos,
    crowdMemoLog,
    filterType = 'new'
  ) => {
    if (filterType == 'new') {
      return tracerMemos.filter(
        (memo) =>
          (memo.memo != atMemos?.[`${memo?.dtc}_${memo?.acronym}`]?.memo ||
            memo.short_desc !=
              atMemos?.[`${memo?.dtc}_${memo?.acronym}`]?.description.substring(
                0,
                128
              )) &&
          new Date(memo.updated_at) >=
            new Date(
              crowdMemoLog?.[`${memo?.dtc}_${memo?.acronym}`]?.updated_at
                ? crowdMemoLog?.[`${memo?.dtc}_${memo?.acronym}`]?.updated_at
                : null
            )
      )
    } else {
      return tracerMemos.filter(
        (memo) =>
          memo.memo != atMemos?.[`${memo?.dtc}_${memo?.acronym}`]?.memo ||
          memo.short_desc !=
            atMemos?.[`${memo?.dtc}_${memo?.acronym}`]?.description.substring(
              0,
              128
            )
      )
    }
  }

  const loadMoreMemos = () => {
    if (memos.length > totalMemos) {
      setTotalMemos(totalMemos + 10)
    }
  }

  const memoAction = async (action, index) => {
    if (action == 'accept') {
      let res = await postRequest(
        `/api/dtc_memos/action/accept/${vehicle}/`,
        selectedItem
      )
      if (res?.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: res.msg,
          },
        })

        let tempMemos = [...memos]
        tempMemos.splice(index, 1)
        setMemos(tempMemos)
      } else {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res.msg,
          },
        })
      }
    } else {
      let res = await postRequest(
        `/api/dtc_memos/action/reject/${vehicle}/`,
        selectedItem
      )
      let tempMemos = [...memos]
      tempMemos[index]['status'] = 'rejected'
      setMemos(tempMemos)
    }
  }

  const filterRecords = (filterType) => {
    setMemos(filterMemos(memoList, atMemos, crowdSource, filterType))
    setRecordType(filterType)
  }

  return (
    <Modal
      onClose={() => {
        getListData()
        memoDispatch({ type: SHOW_FETCH_MEMO_POPUP, data: false })
      }}
      show={memoState.show_fetch_memo_popup}
      size={`w-4\/5`}
    >
      <ModalHeader className={'text-white justify-between flex'}>
        <div>Crowdsourced Memos Review</div>
        <div className="text-base">
          {recordType == 'new' ? (
            <Button
              type="submit"
              className={`cursor-pointer btn`}
              onClick={(e) => {
                filterRecords('all', state?.tracer_mappings)
              }}
              text={'Show All Records'}
            />
          ) : (
            <Button
              type="submit"
              className={`cursor-pointer btn`}
              onClick={(e) => {
                filterRecords('new', state?.tracer_mappings)
              }}
              text={'Show New Records'}
            />
          )}
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="">
          <div className="font-light">
            <MemoHeader />
            {memos.slice(0, totalMemos)?.map((memo, index) => {
              return (
                <MemosRow
                  {...memo}
                  key={`memo-${index}`}
                  setSelectedItem={setSelectedItem}
                  selectedItem={selectedItem}
                  memoAction={(action) => {
                    memoAction(action, index)
                  }}
                  index={index}
                  showAction={true}
                  atMemo={atMemos?.[`${memo?.dtc}_${memo?.acronym}`]}
                />
              )
            })}
            {memos?.length < 1 && <NoRecordsFound />}
            {memos.length > totalMemos && (
              <div className="flex flex-row w-full text-white px-3 underline text-blue-500 font-normal justify-end">
                <span
                  onClick={() => {
                    loadMoreMemos()
                  }}
                  className="underline cursor-pointer"
                >
                  Load More
                </span>
              </div>
            )}
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default TracerMemos
